import React, { useMemo } from 'react';

export const useLegalDocsMarkdownComponents = () => {
	return useMemo(
		() => ({
			figure: ({ node, ...props }: any) => (
				<figure
					style={{
						margin: '0'
					}}
					{...props}
				/>
			),
			table: ({ node, ...props }: any) => (
				<div style={{ margin: '0', overflowX: 'scroll' }}>
					<table
						style={{
							borderCollapse: 'collapse',
							width: '100%',
							border: '1px solid #ddd',
							overflowX: 'scroll'
						}}
						{...props}
					/>
				</div>
			),
			th: ({ node, ...props }: any) => (
				<th
					style={{
						border: '1px solid #ddd',
						padding: '8px',
						textAlign: 'left',
						backgroundColor: '#eceef4'
					}}
					{...props}
				/>
			),
			td: ({ node, ...props }: any) => (
				<td
					style={{
						border: '1px solid #ddd',
						padding: '8px',
						wordWrap: 'break-word',
						minWidth: '100px'
					}}
					{...props}
				/>
			),
			p: ({ node, ...props }: any) => <p style={{ textAlign: 'justify', color: '#4a4a4a' }} {...props} />,
			h1: ({ node, ...props }: any) => (
				<h1
					style={{
						textAlign: 'justify',
						color: '#4a4a4a',
						fontSize: '20px',
						fontWeight: 'bold'
					}}
					{...props}
				/>
			)
		}),
		[]
	);
};
